// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { forEach } from 'lodash'
import { errorCodes, getUserFriendlyErrorMessage } from './errormessages'
import { isDuplicatedLicenses, validateEmail, validateLicenses } from './common'

import { createAdminMember, createProviderMember } from '../store/newMember/newMemberThunk'
import { visibilityTypes } from '../pages/member/Constants'

export const prefixOptions = [' ', 'Dr.', 'Mr.', 'Mrs.', 'Ms.', 'Prof.']
export const suffixOptions = [' ', 'DO', 'LPC', 'MD', 'MPH', 'NP', 'PA', 'PhD', 'RN']
export const medicalProfessionOptions = [
  'Acupuncturist',
  'Addiction Medicine Physician',
  'Allergist',
  'Anesthesiologist',
  'Audiologist',
  'Bariatric Physician',
  'Cardiac Electrophysiologist',
  'Cardiologist',
  'Cardiothoracic Surgeon',
  'Certified Rehabilitation Counselor',
  'Chiropractor',
  'Colorectal Surgeon',
  'Dentist',
  'Dermatologist',
  'Dietitian',
  'Ear, Nose & Throat Doctor',
  'Emergency Medicine Physician',
  'Endocrinologist',
  'Endodontist',
  'Family Physician',
  'Gastroenterologist',
  'Geneticist',
  'Geriatrician',
  'Hand Surgeon',
  'Hematologist',
  'Immunologist',
  'Infectious Disease Specialist',
  'Integrative Health Medicine Specialist',
  'Internist',
  'Licensed Professional Counselor',
  'LPN',
  'Medical Assistant',
  'Medical Ethicist',
  'Microbiologist',
  'Midwife',
  'Naturopathic Doctor',
  'Nephrologist',
  'Neurologist',
  'Neuropsychiatrist',
  'Neurosurgeon',
  'Nurse Practitioner',
  'Nutritionist',
  'OB-GYN',
  'Occupational Medicine Specialist',
  'Oncologist',
  'Only Doctors Notes',
  'Ophthalmologist',
  'Optometrist',
  'Oral Surgeon',
  'Orthodontist',
  'Orthopedic Surgeon',
  'Pain Management Specialist',
  'Pathologist',
  'Pediatric Dentist',
  'Pediatrician',
  'Periodontist',
  'Physiatrist',
  'Physical Therapist',
  'Physician Assistant',
  'Plastic Surgeon',
  'Podiatrist',
  'Preventive Medicine Specialist',
  'Primary Care Doctor',
  'Prosthodontist',
  'Provider',
  'Psychiatrist',
  'Psychologist',
  'Psychosomatic Medicine Specialist',
  'Psychotherapist',
  'Pulmonologist',
  'Radiation Oncologist',
  'Radiologist',
  'Reproductive Endocrinologist',
  'Rheumatologist',
  'Sleep Medicine Specialist',
  'Social Worker',
  'Sports Medicine Specialist',
  'Surgeon',
  'Surgical Oncologist',
  'Travel Medicine Specialist',
  'Urgent Care Specialist',
  'Urological Surgeon',
  'Urologist',
  'Vascular Surgeon',
]
export const statesOptions = [
  'Alabama AL',
  'Alaska AK',
  'Arizona AZ',
  'Arkansas AR',
  'California CA',
  'Colorado CO',
  'Connecticut CT',
  'Delaware DE',
  'District of Columbia DC',
  'Florida FL',
  'Georgia GA',
  'Hawaii HI',
  'Idaho ID',
  'Illinois IL',
  'Indiana IN',
  'Iowa IA',
  'Kansas KS',
  'Kentucky KY',
  'Louisiana LA',
  'Maine ME',
  'Maryland MD',
  'Massachusetts MA',
  'Michigan MI',
  'Minnesota MN',
  'Mississippi MS',
  'Missouri MO',
  'Montana MT',
  'Nebraska NE',
  'Nevada NV',
  'New Hampshire NH',
  'New Jersey NJ',
  'New Mexico NM',
  'New York NY',
  'North Carolina NC',
  'North Dakota ND',
  'Ohio OH',
  'Oklahoma OK',
  'Oregon OR',
  'Pennsylvania PA',
  'Rhode Island RI',
  'South Carolina SC',
  'South Dakota SD',
  'Tennessee TN',
  'Texas TX',
  'Utah UT',
  'Vermont VT',
  'Virginia VA',
  'Washington WA',
  'West Virginia WV',
  'Wisconsin WI',
  'Wyoming WY',
]
export const roleOptions = ['Admin', 'Provider']
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setLicensesVisitTypesDropdownOptions = (id, newOptions, setLicenseArrayCallback) => {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLicenseArrayCallback((prev) =>
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    prev.map((t) => (t.licenseBlockId === id ? { ...t, licenseVisitTypesOptions: newOptions } : t)),
  )
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function isEllipsisActive(e) {
  return e?.offsetWidth < e?.scrollWidth
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const onDeleteLicense = (id, licensesArray, setLicenseArrayCallback) => {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLicenseArrayCallback(licensesArray.filter((t) => t.licenseBlockId !== id))
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const checkAllLicensesFields = (licensesArray, setLicensesArrayCallback) => {
  let issues = 0
  let licenseIssue = 0

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const newLicenseBlock = licensesArray.map((t) => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const list = t.licenseVisitTypesOptions.filter((option) => option.isSelected)

    if (t?.licenseNumberValue && !t.licenseNumberValue?.match(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9.\- ]+$/gm)) {
      licenseIssue += 3

      t = {
        ...t,
        licenseNumberError: true,
        licenseNumberLocalError: getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID),
      }
    }
    if ((list.length === 0 || t.stateLicenseValue?.trim().length === 0) && !t.licenseNumberError) {
      issues += 1
      return {
        ...t,
        licenseVisitTypesDropdownValueError: list.length === 0,
        licenseVisitTypesDropdownValueLocalError:
          list.length === 0 ?
            getUserFriendlyErrorMessage(errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE, null, 'Service types')
          : '',
        licenseStateLicenseValueError: t.stateLicenseValue?.trim().length === 0,
        licenseStateLicenseValueLocalError:
          t.stateLicenseValue?.trim().length === 0 ?
            getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'State license')
          : '',
      }
    }

    // @ts-expect-error TS2367 -- MIGRATION: not approved, fix when encountered
    if (!list.length === 0 && t.licenseNumberError) {
      if (
        t.licenseNumberLocalError === '211 - Shared License.' ||
        t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID)
      ) {
        licenseIssue += 3
      } else {
        licenseIssue += 1
      }
      return t
    }

    if ((list.length === 0 || t.stateLicenseValue?.trim().length === 0) && t.licenseNumberError) {
      if (
        t.licenseNumberLocalError === '211 - Shared License.' ||
        t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID)
      ) {
        licenseIssue += 3
      } else {
        licenseIssue += 1
      }

      return {
        ...t,
        licenseVisitTypesDropdownValueError: list.length === 0,
        licenseVisitTypesDropdownValueLocalError:
          list.length === 0 ?
            getUserFriendlyErrorMessage(errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE, null, 'Service types')
          : '',
        licenseStateLicenseValueError: t.stateLicenseValue?.trim().length === 0,
        licenseStateLicenseValueLocalError:
          t.stateLicenseValue?.trim().length === 0 ?
            getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'State license')
          : '',
      }
    }

    if (
      t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID) ||
      t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'License no.')
    ) {
      licenseIssue += 3
    }
    return t
  })
  setLicensesArrayCallback(newLicenseBlock)
  validateLicenses(newLicenseBlock, setLicensesArrayCallback)
  if (issues !== 0) {
    return issues !== 0
  }
  if (licenseIssue >= 2) {
    return licenseIssue >= 2
  }
}

export const onClickSafeMemberButton = (
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  dispatch,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setPageErrorCallback,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  firstNameState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setFirstNameLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setFirstNameErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  lastNameState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLastNameLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLastNameErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  emailState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setEmailLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setEmailErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  prefixState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  suffixState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  roleState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setRoleLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setRoleErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isExcludedFromMarketingReports,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  professionalTitle,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setProfessionalTitleError,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setProfessionalTitleLocalError,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  licensesArray,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLicensesArray,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  member,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  type,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  phoneNumber,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  phoneNumberError,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isProviderWithLicense,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  productivityData,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  npi,
  // This branch saves via a caller-provided callback (React Query editMember in member.tsx),
  // not the legacy redux dispatch — the create flow still dispatches below.
  onEditMemberCallback: (role: string, body: unknown) => void,
) => {
  if (
    firstNameState?.trim() === '' ||
    (professionalTitle?.trim() === '' && roleState === 'Provider') ||
    lastNameState?.trim() === '' ||
    emailState?.trim() === '' ||
    validateEmail(emailState) === null ||
    !emailState?.trim().toLowerCase().endsWith('@quick.md') ||
    roleState?.trim() === '' ||
    (checkAllLicensesFields(licensesArray, setLicensesArray) && roleState === 'Provider' && isProviderWithLicense) ||
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    (isDuplicatedLicenses(licensesArray, setLicensesArray) && roleState === 'Provider' && isProviderWithLicense) ||
    phoneNumberError
  ) {
    dispatch(setPageErrorCallback(errorCodes.FILL_ALL_FIELDS))
    if (firstNameState?.trim() === '') {
      setFirstNameLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'First name'))
      setFirstNameErrorCallBack(true)
    }
    if (professionalTitle?.trim() === '' && roleState === 'Provider') {
      setProfessionalTitleLocalError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Professional title'))
      setProfessionalTitleError(true)
    }
    if (lastNameState?.trim() === '') {
      setLastNameLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Last name'))
      setLastNameErrorCallBack(true)
    }
    if (roleState?.trim() === '') {
      setRoleLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Role'))
      setRoleErrorCallBack(true)
    }
    if (
      (checkAllLicensesFields(licensesArray, setLicensesArray) || isDuplicatedLicenses(licensesArray)) &&
      roleState === 'Provider'
    ) {
      checkAllLicensesFields(licensesArray, setLicensesArray)
    }
    if (validateEmail(emailState) === null) {
      setEmailLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Email'))
      setEmailErrorCallBack(true)
    } else if (!emailState?.trim().toLowerCase().endsWith('@quick.md')) {
      setEmailLocalErrorCallBack('Email must use the @quick.md domain')
      setEmailErrorCallBack(true)
    }
    if (emailState?.trim() === '') {
      setEmailLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Email'))
      setEmailErrorCallBack(true)
    }
  } else {
    if (isProviderWithLicense) {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setLicensesArray(licensesArray.map((t) => ({ ...t, licenseNumberError: false, licenseNumberLocalError: '' })))
    }
    if (roleState === 'Admin') {
      const newMemberAdminBody = {
        Email: emailState,
        FirstName: firstNameState,
        LastName: lastNameState,
        Prefix: prefixState?.trim(),
        Suffix: suffixState?.trim(),
      }
      if (type === 'edit') {
        onEditMemberCallback(roleState, newMemberAdminBody)
      } else {
        dispatch(createAdminMember(newMemberAdminBody))
      }
    } else if (roleState === 'Provider') {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const licensesCorrenctBody = licensesArray?.map((t) => ({
        LicenseId: t.licenseBlockId.indexOf('autoGenerated') !== -1 ? null : t.licenseBlockId,
        VisitTypes: t.licenseVisitTypesOptions
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .map((item) =>
            item.isSelected ? { VisitTypeId: item.VisitTypeId, VisibilityType: item.visibilityType.name } : null,
          )
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .filter((serviceType) => serviceType !== null),
        Number: t.licenseNumberValue ? t.licenseNumberValue : '',
        StateCode: t.stateLicenseValue ? t.stateLicenseValue.slice(-2) : '',
        LicensedBy: t.licensedByValue ? t.licensedByValue?.trim() : '',
        // CSL/DEA fields are captured by the redesigned LicenseFormPage in new-members.jsx;
        // the API contract (DoctorLicenseAdminApiInContract) accepts them as nullable.
        CslNumber: t.cslNumber || null,
        DeaNumber: t.deaNumber || null,
        DeaStateCode: t.deaStateCode || null,
      }))

      const shared = {
        PhoneNumber: phoneNumber,
        Email: emailState,
        FirstName: firstNameState,
        LastName: lastNameState,
        Prefix: prefixState?.trim(),
        Suffix: suffixState?.trim(),
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        ProfessionalTitles: professionalTitle.split(';').map((t) => t?.trim()),
        IsExcludedFromMarketingReports: isExcludedFromMarketingReports,
        NationalProviderIdentifier: npi || null,
      }

      const newMemberProviderBody = {
        ...shared,
        ProductivityOverrides: productivityData,
        Licenses:
          isProviderWithLicense ?
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            licensesCorrenctBody.map((t) => ({
              LicenseId: t.LicenseId,
              VisitTypes: [...t.VisitTypes],
              Number: t.Number,
              StateCode: t.StateCode,
              LicensedBy: t.LicensedBy,
              CslNumber: t.CslNumber,
              DeaNumber: t.DeaNumber,
              DeaStateCode: t.DeaStateCode,
            }))
          : null,
      }

      if (type === 'edit') {
        onEditMemberCallback(roleState, shared)
      } else {
        dispatch(createProviderMember(newMemberProviderBody))
      }
    }
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function imageSize(url) {
  const img = document.createElement('img')

  const promise = new Promise((resolve) => {
    img.onload = () => {
      // Natural size is the actual image size regardless of rendering.
      // The 'normal' `width`/`height` are for the **rendered** size.
      const width = img.naturalWidth
      const height = img.naturalHeight

      // Resolve promise with the width and height
      resolve({ width, height })
    }
  })

  // Setting the source makes it start downloading and eventually call `onload`
  img.src = url

  return promise
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitServiceObject = (service, visit) => ({
  value: `${
    service.Name.indexOf('-') !== -1 ? service.Name.substring(0, service.Name.lastIndexOf('-')) : service.Name
  } (${visit.Name})`,
  serviceValue:
    service.Name.indexOf('-') !== -1 ? service.Name.substring(0, service.Name.lastIndexOf('-')) : service.Name,
  visibilityType: visibilityTypes.allPatients,
  name: visit.Name,
  ServiceTypeId: service.ServiceTypeId,
  VisitTypeId: visit.VisitTypeId,
  isSelected: false,
  VisitTypes: [visit],
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getProductivityList = (visitArray, productivityArray?) => {
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  const newProductivityArray = []
  if (productivityArray?.length) {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    productivityArray.forEach((productivity) => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      if (visitArray.some((visitType) => visitType.VisitTypeId === productivity.VisitTypeId)) {
        newProductivityArray.push(productivity)
      }
    })
  }

  // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
  const selectedVisitTypes = [...visitArray, ...newProductivityArray]
  const serviceObjects = {}
  selectedVisitTypes.forEach((serviceType) => {
    if (serviceType.isActive) {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      if (serviceObjects[serviceType.ServiceTypeId]) {
        let found = false

        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        serviceObjects[serviceType.ServiceTypeId].VisitTypes = serviceObjects[serviceType.ServiceTypeId].VisitTypes.map(
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          (visitType) => {
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            serviceType.VisitTypes.forEach((type) => {
              if (type.VisitTypeId === visitType.VisitTypeId) {
                found = true

                visitType = { ...visitType, ...type }
              }
            })
            return visitType
          },
        )
        if (!found) {
          // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
          serviceObjects[serviceType.ServiceTypeId].VisitTypes = [
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...serviceObjects[serviceType.ServiceTypeId].VisitTypes,
            ...serviceType.VisitTypes,
          ]
        }
      } else {
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        serviceObjects[serviceType.ServiceTypeId] = { ...serviceType }
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        serviceObjects[serviceType.ServiceTypeId].VisitTypes = [...serviceType.VisitTypes]
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        serviceObjects[serviceType.ServiceTypeId].value = serviceType.serviceValue
      }
    }
  })

  return Object.keys(serviceObjects).map((key) => serviceObjects[key])
}
